import { Injectable } from '@angular/core';
import { Database, get, push, ref, set, update } from '@angular/fire/database';
import { Auth, signInAnonymously } from '@angular/fire/auth';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { StorageKey, StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  constructor(
    private auth: Auth,
    public db: Database,
    public angularFireAuth: AngularFireAuth,
    private storageService: StorageService,
  ) {}

  anonymousLogin(): void {
    signInAnonymously(this.auth)
      .then(() => this.setUuid())
      .catch(console.error);
  }

  async updateRealtimeDatabase(dbPath: string, data: object): Promise<void> {
    const dbRef = ref(this.db, dbPath);

    if (!dbRef || !dbPath || !data) {
      throw new Error('Invalid arguments');
    }

    try {
      await update(dbRef, data);
    } catch (error) {
      console.error(error);
    }
  }

  async setRealtimeDatabase(dbPath: string, data: object) {
    const dbRef = ref(this.db, dbPath);

    if (!dbRef || !dbPath || !data) {
      throw new Error('Invalid arguments');
    }

    return await set(dbRef, data).then().catch(console.error);
  }

  async readRealtimeDatabase<T = unknown>(dbPath: string): Promise<T | null> {
    const dbRef = ref(this.db, dbPath);

    if (!dbRef || !dbPath) {
      throw new Error('Invalid arguments');
    }

    return await get(dbRef)
      .then((snapshot) => (snapshot.exists() ? snapshot.val() : null))
      .catch((e) => {
        console.error(e);
        return null;
      });
  }

  async insertData(dbPath: string, data: object) {
    const dbRef = ref(this.db, dbPath);

    if (!dbRef || !dbPath) {
      throw new Error('Invalid arguments');
    }

    const newEntity = push(dbRef);
    return await set(newEntity, data).catch((e) => {
      console.error(e);
      return null;
    });
  }

  setUuid() {
    this.angularFireAuth.user.subscribe((r) => r.uid && this.storageService.set(StorageKey.UUID, r.uid));
  }
}
